/**
 * 公告详情路由
 */
"use strict";
angular.module("noticeDetailsRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("noticedetails", {
        url: "/noticedetails?noticeId&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div class="" ui-view="main"></div>' +
                    '</div>'
            },
            "header@noticedetails": {
                templateUrl: 'header/backstageHeader_tpl.html',
                controller: 'backstageHeaderCtrl'
            },
            "main@noticedetails": {
                templateUrl: "./main/backstage/noticeManagement/noticeDetails/noticeDetails_tpl.html",
                controller: "noticeDetailsCtrl"
            }
        }
    });
}]);